import { Box } from "@chakra-ui/react";

import OrganizationTicketsTable from "../../tables/daily/OrganizationTicketsTable";
import EnterpriseReportSummary from "../../../reports/EnterpriseReportSummary";
import { buildTicketVolumeInsights } from "../../../../store/reportEnterpriseInsights";

const OrganizationTickets = ({ data }) => {
  const insights = buildTicketVolumeInsights([data], { scopeLabel: "Organization" });

  return (
    <Box>
      <EnterpriseReportSummary
        title="Daily Ticket Operations Summary"
        kpis={insights.kpis}
        tables={insights.tables}
        notes={insights.notes}
      />
      <OrganizationTicketsTable
        table={[data]}
        chart={data.chart}
        
      />
    </Box>
  );
};

export default OrganizationTickets;
